import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'VirtualGroup',
	friendly_name: 'Virtual Device',
	family: 'virtual',
	modes: {
		virtual: {
			channels: 1,
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
	},
};
